import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Typography } from '@finam/web-ui-kit';
import isEmail from 'validator/lib/isEmail';
import { useLocale } from '../../../i18n';
import useForm from '../../../utils/useForm';
import PhoneField from './PhoneField';
import { isPhone } from './validators';
import Form from '../../Core/Form';
import EmailField from '../../Core/EmailField';
import Button from '../../Core/Button';
import Agreement from '../../Agreement';
import SubmitError from '../../Core/SubmitError';
import { HaveAccountWrap, SignInLink } from './RegistrationForm.styles';

var RegistrationForm = function RegistrationForm(_ref) {
  var initialData = _ref.data,
      hintTooltip = _ref.hintTooltip,
      autoFocus = _ref.autoFocus,
      submitButton = _ref.submitButton,
      onRegister = _ref.onRegister,
      onClose = _ref.onClose;

  var _useLocale = useLocale(),
      i18n = _useLocale.i18n,
      i18nServerError = _useLocale.i18nServerError;

  var validate = useCallback(function (data) {
    var newErrors = {};

    if (data.phone === undefined || data.phone === '') {
      newErrors.phone = i18n('registration.error.required');
    } else if (!isPhone(data.phone)) {
      newErrors.phone = i18n('registration.error.invalidPhone');
    }

    if (data.email === undefined || data.email === '') {
      newErrors.email = i18n('registration.error.required');
    } else if (!isEmail(data.email)) {
      newErrors.email = i18n('registration.error.invalidEmail');
    }

    return newErrors;
  }, [i18n]);

  var _useForm = useForm({
    initialData: initialData,
    validate: validate,
    onSubmit: onRegister
  }),
      formData = _useForm.formData,
      submitting = _useForm.submitting,
      submitError = _useForm.submitError,
      onChange = _useForm.onChange,
      onBlur = _useForm.onBlur,
      onSubmit = _useForm.onSubmit,
      getErrorText = _useForm.getErrorText;

  var submitButtonText = submitButton || i18n('next');
  return _jsxs(Form, Object.assign({
    id: "txauth-widget-registration-form",
    autoComplete: "off",
    noValidate: true,
    onSubmit: onSubmit
  }, {
    children: [submitError && _jsx(SubmitError, {
      error: i18nServerError(submitError, 'error')
    }), _jsx(PhoneField, {
      name: "phone",
      label: i18n('phone'),
      autoFocus: autoFocus,
      value: formData.phone,
      disabled: submitting,
      onChange: onChange,
      onBlur: onBlur,
      message: i18n('registration.hint.phone'),
      errorText: getErrorText('phone'),
      hintTooltip: hintTooltip
    }), _jsx(EmailField, {
      name: "email",
      label: i18n('email'),
      value: formData.email,
      disabled: submitting,
      onChange: onChange,
      onBlur: onBlur,
      errorText: getErrorText('email'),
      hintTooltip: hintTooltip
    }), _jsx(Button, Object.assign({
      type: "submit",
      loading: submitting,
      fullWidth: true
    }, {
      children: submitButtonText
    })), _jsx(Agreement, {
      submitButtonText: submitButtonText
    }), onClose && _jsxs(HaveAccountWrap, {
      children: [_jsx(Typography, Object.assign({
        variant: "body14",
        color: "secondary"
      }, {
        children: i18n('alreadyHaveAccount')
      })), _jsx(SignInLink, Object.assign({
        onClick: onClose,
        "data-testid": "sign-in"
      }, {
        children: i18n('signIn')
      }))]
    })]
  }));
};

export default RegistrationForm;